import Vue from 'vue'
import Vuex from 'vuex'

import { getField, updateField } from 'vuex-map-fields'
import { uuid } from 'vue-uuid'
import { Person, UserSession } from 'blockstack'
import { userSession } from '@/userSession'
// import NProgress from 'nprogress'

require('es6-promise').polyfill()

Vue.use(Vuex)

const BLOCKSTACK_DATA = 'cabinetapps.maps'

const store = new Vuex.Store({
  state: {
    toolbarEnabled: false,
    lists: null,
    lists_lastSave: [],
    currentListIndex: null,
    recent: [],
    listData: {
      id: null,
      title: 'Untitled Map',
      type: 'bullet',
      mapInfo: {
        config: {
          longitude: -73.98226832965486,
          latitude: 40.72995403173775,
          zoom: 10.2,
          pitch: 0
        }
      },
      items: [
        {
          id: uuid.v4(),
          title: null,
          description: null,
          coordinates: null
        }
      ],
      publish: false,
      publicId: null,
      published: false,
      note: '<p></p>',
      createdAt: null
    },
    listData_lastSave: {},
    list_isLoading: false,
    list_isSaving: false,
    list_isDeleting: false,
    saveTimeout: null,
    blockstack: {
      user: null,
      userData: null,
      userSession: null
    }
  },
  getters: {
    getField,
    needsSave: (state, getters) => {
      // console.log('[state] called needsSave')
      return getters.needsSave_currentList || getters.needsSave_lists
    },
    needsSave_currentList: state => {
      return JSON.stringify(state.listData) !== JSON.stringify(state.listData_lastSave)
    },
    needsSave_lists: state => {
      return state.lists ? JSON.stringify(state.lists) !== JSON.stringify(state.lists_lastSave) : false
    },
    listsCount: (state) => {
      return state.lists ? state.lists.count : -1
    },
    enableToolbar: (state) => {
      return state.toolbarEnabled && !state.list_isSaving && !state.list_isDeleting
    }
  },
  mutations: {
    updateField,
    SET_ENABLETOOLBAR: (state, value) => {
      state.toolbarEnabled = value
    },
    SET_LIST: (state, listData) => {
      state.listData = listData
    },
    SET_LISTDATA_LAST_SAVE: (state, listData) => {
      state.listData_lastSave = listData
    },
    SET_LIST_LOADING: (state, loading) => {
      state.list_isLoading = loading
    },
    SET_CURRENT_LIST_INDEX: (state, newIndex) => {
      state.currentListIndex = newIndex
    },
    SET_LIST_CREATEDAT: (state, dateString) => {
      state.listData.createdAt = dateString
    },
    SET_LIST_SAVING: (state, value) => {
      state.list_isSaving = value
    },
    SET_LIST_DELETING: (state, value) => {
      state.list_isDeleting = value
    },
    ADD_NEW_ITEM: (state) => {
      state.listData.items.push({
        id: uuid.v4(),
        title: 'Untitled Placemark',
        description: null,
        latitude: 0,
        longitude: 0
      })
    },
    UPDATE_ITEM: (state, { index, newValue }) => {
      Vue.set(state.listData.items[index], 'value', newValue)
    },
    UPDATE_NOTE: (state, newValue) => {
      state.listData.note = newValue
    },
    SET_ITEM_FOCUS: (state, index) => {
      Vue.set(state.listData.items[index], 'editState', 'focus')
    },
    SET_ITEM_BLUR: (state, index) => {
      Vue.set(state.listData.items[index], 'editState')
    },
    DELETE_ITEM: (state, index) => {
      Vue.delete(state.listData.items, index)
    },
    UPDATE_SAVED_TIME: (state) => {
      state.lastSaved = Date()
    },
    SET_USER_SESSION: (state) => {
      state.blockstack.userSession = userSession
    },
    SET_USER_PROPERTIES: (state) => {
      state.blockstack.userData = state.blockstack.userSession.loadUserData()
      state.blockstack.user = new Person(state.blockstack.userData.profile)
      state.blockstack.user.username = state.blockstack.userData.username
    },
    SET_LISTS: (state, lists) => {
      state.lists = lists
    },
    SET_LISTS_LAST_SAVE: (state, lists) => {
      state.lists_lastSave = lists
    },
    SET_LISTDATA_PUBLICID: (state, publicId) => {
      state.listData.publicId = publicId
    },
    SET_LISTDATA_PUBLISHED: (state, published) => {
      state.listData.published = published
    },
    ADD_LIST: (state, list) => {
      state.lists.unshift(list)
    },
    // UPDATE_LIST: (state, newEntry) => {
    //   console.log('[state in update_list]')
    //   Vue.set(state.lists[state.currentListIndex], )
    // },
    UPDATE_CURRENT_LIST_TITLE: (state, newTitle) => {
      // console.log('setting title of', state.currentListIndex)
      // console.log('new title is', newTitle)
      Vue.set(state.lists[state.currentListIndex], 'title', newTitle)
    },
    DELETE_LIST: (state, index) => {
      if (index >= 0) {
        Vue.delete(state.lists, index)
      }
    }
    // SYNC_TITLE: (state, newTitle) => {
    //   // after a change in title, update the title in lists
    //   // console.log('[store] got sync: ', newTitle)
    //   // console.log('will change list at index: ', state.currentListIndex)
    //   // console.log('old title: ', state.lists[state.currentListIndex])
    //   // state.lists[state.currentListIndex].title = newTitle
    //   const index = state.currentListIndex
    //   if (index >= 0) {
    //     state.lists[index].title = newTitle
    //     // console.log('changed. now is', state.lists)
    //   }
    // }
  },
  actions: {
    // nukeData ({ state }) {
    //   console.log('nuking data')
    //   const lists = state.lists
    //   var i
    //   for (i = 0; i < lists.length; i++) {
    //     userSession.deleteFile(lists[i].id).catch(error => {
    //       console.log('error: ', error)
    //     })
    //   }
    //   userSession.deleteFile(BLOCKSTACK_DATA).catch(error => {
    //     console.log('error: ', error)
    //   })
    // },
    loadLists ({ state, dispatch, commit }) {
      // console.log('[state] loadLists')
      if (state.lists != null) {
        // console.log('not loading, just returning lists: ', state.lists)
        return state.lists
      } else {
        // console.log('loading lists from file')
        return userSession
          .getFile(BLOCKSTACK_DATA) // decryption is enabled by default
          .then(listsData => {
            // console.log('got listsData: ', listsData)
            var lists = JSON.parse(listsData || '[]')
            // console.log('[state] retrieved lists from file: ', lists)
            commit('SET_LISTS', lists)
            var listsLastSave = JSON.parse(listsData || '[]')
            commit('SET_LISTS_LAST_SAVE', listsLastSave)
            // moved load new list
            return lists
          })
      }
    },
    loadList ({ state, dispatch, commit }, listFilename) {
      // console.log('[state] loadList', listFilename)
      return userSession
        .getFile(listFilename) // decryption is enabled by default
        .then(listData => {
          var list = JSON.parse(listData)
          if (list) {
            // console.log('setting: ', list)
            commit('SET_LIST', list)
            commit('SET_LISTDATA_LAST_SAVE', JSON.parse(listData))
            return list
          } else {
            return null
          }
        })
    },
    loadPublicResource ({ state, dispatch, commit }, { userId, resource }) {
      const options = {
        username: userId, // the Blockstack ID of the user for which to lookup the file
        // app: 'https://culinary.cabinet.app', // defaults to current app
        decrypt: false
      }
      var publicUserSession = new UserSession()
      // const options = { decrypt: false }
      return publicUserSession
        .getFile(resource, options) // decryption is enabled by default
        .then(listData => {
          var list = JSON.parse(listData)
          if (list) {
            // console.log('setting: ', list)
            commit('SET_LIST', list)
            commit('SET_LISTDATA_LAST_SAVE', JSON.parse(listData))
            return list
          } else {
            return null
          }
        })
        .catch((error) => {
          console.log('got error in public load list: ', listFilename)
          console.log('error is: ', error)
        })
    },
    switchList ({ state, dispatch, commit }, listIndex) {
      if (listIndex >= 0 && listIndex < state.lists.length) {
        const listId = state.lists[listIndex].id
        commit('SET_LIST_LOADING', true)
        return dispatch('loadList', listId).then(() => {
          commit('SET_CURRENT_LIST_INDEX', listIndex)
          commit('SET_LIST_LOADING', false)
        })
      }
    },
    new ({ state, dispatch, commit }) {
      // console.log('[state] new')
      // Check if signed in.
      if (userSession.isUserSignedIn()) {
        return dispatch('generateNewList').then(list => {
          // console.log('[state] generated new list: ', list)
          commit('SET_LIST', list)
          commit('SET_CURRENT_LIST_INDEX', null)
          return list
        })
      } else {
        console.log('user is not signed in')
      }
    },
    async save ({ state, getters, commit, dispatch }) {
      if (userSession.isUserSignedIn()) {
        if (!getters.needsSave) {
          return
        }

        // Update public file with new publish state
        // TODO - alternatively delete the public file if not published
        if (state.listData.publish || state.listData.published) {
          // Save published version
          // console.log('saving public')
          await dispatch('savePublicFile')
          // console.log('finished awaiting save public, listdatais: ', state.listData)
        }
        // console.log('after save public')
        // Then save the rest of the file
        var isNewList = state.listData.createdAt === null
        if (isNewList) {
          commit('SET_LIST_CREATEDAT', new Date().toISOString())
        }
        var listId = state.listData.id
        var listTitle = state.listData.title
        var listCreated = state.listData.createdAt
        var listJSON = JSON.stringify(state.listData)

        return userSession.putFile(listId, listJSON).then(() => {
          commit('SET_LISTDATA_LAST_SAVE', JSON.parse(listJSON))

          if (isNewList) {
            commit('ADD_LIST', {
              id: listId,
              title: listTitle,
              createdAt: listCreated // use now
            })
          } else {
            // Check if we need to update the list title
            // console.log('check list title')
            // Find index
            const lists = state.lists
            var result = null
            lists.some(function (lst, index) {
              // console.log('scanning: ', lst)
              if (lst.id === listId) {
                result = index
                return true
              }
            })
            if (result != null) {
              commit('SET_CURRENT_LIST_INDEX', result)
              commit('UPDATE_CURRENT_LIST_TITLE', listTitle)
              return dispatch('updateListsFile')
            }
          }
          return dispatch('updateListsFile')
        })
      } else {
        console.log('user is not signed in')
      }
    },
    savePublicFile ({ state, commit }) {
      var publicId
      // console.log('in save public. listdata is: ', state.listData)
      if (state.listData.publicId != null) {
        // console.log('getting saved publicId')
        publicId = state.listData.publicId
      } else {
        // console.log('generating new publicId')
        publicId = uuid.v4()
      }

      var listJSON = JSON.stringify(state.listData)

      const filename = 'public/' + publicId
      const options = { encrypt: false }
      // console.log('writing to file: ', filename)
      return userSession.putFile(filename, listJSON, options).then(() => {
        commit('SET_LISTDATA_PUBLICID', publicId)
        // console.log('finished writing, updated publicId: ', publicId)
        commit('SET_LISTDATA_PUBLISHED', true)
        // console.log('listData is now: ', state.listData)
      })
    },
    // save ({ state, getters, commit, dispatch }) {
    //   if (userSession.isUserSignedIn()) {
    //     if (!getters.needsSave) {
    //       return
    //     }
    //     var isNewList = state.listData.createdAt === null
    //     if (isNewList) {
    //       commit('SET_LIST_CREATEDAT', new Date().toISOString())
    //     }
    //     var listId = state.listData.id
    //     var listTitle = state.listData.title
    //     var listCreated = state.listData.createdAt
    //     var listJSON = JSON.stringify(state.listData)

    //     return userSession.putFile(listId, listJSON).then(() => {
    //       commit('SET_LISTDATA_LAST_SAVE', JSON.parse(listJSON))

    //       if (isNewList) {
    //         commit('ADD_LIST', {
    //           id: listId,
    //           title: listTitle,
    //           createdAt: listCreated // use now
    //         })
    //       } else {
    //         // Check if we need to update the list title
    //         // console.log('check list title')
    //         // Find index
    //         const lists = state.lists
    //         var result = null
    //         lists.some(function (lst, index) {
    //           // console.log('scanning: ', lst)
    //           if (lst.id === listId) {
    //             result = index
    //             return true
    //           }
    //         })
    //         if (result != null) {
    //           commit('SET_CURRENT_LIST_INDEX', result)
    //           commit('UPDATE_CURRENT_LIST_TITLE', listTitle)
    //           return dispatch('updateListsFile')
    //         }
    //       }
    //       return dispatch('updateListsFile')
    //     })
    //   } else {
    //     console.log('user is not signed in')
    //   }
    // },
    updateListsFile ({ state, commit }) {
      // Then save the lists file if necessary
      if (JSON.stringify(state.lists) !== JSON.stringify(state.lists_lastSave)) {
        var listsJSON = JSON.stringify(state.lists)
        return userSession.putFile(BLOCKSTACK_DATA, listsJSON).then(() => {
          commit('SET_LISTS_LAST_SAVE', JSON.parse(listsJSON))
        })
      }
    },
    deleteCurrentList ({ state, commit, dispatch }) {
      if (userSession.isUserSignedIn()) {
        if (state.listData.createdAt == null) {
          console.log('doing clear list')
          return dispatch('clearList')
        }

        // console.log('deleting existing list')
        const listId = state.listData.id
        const lists = state.lists
        var result = null
        lists.some(function (lst, index) {
          if (lst.id === listId) {
            result = index
            return true
          }
        })
        if (result != null) {
          commit('SET_CURRENT_LIST_INDEX', result)
        }

        const index = result
        console.log('deleting list ', listId, ' with index ', index)

        // If the list hasn't been saved yet, open a new list
        if (index != null) {
          // first remove the list from the lists array
          commit('DELETE_LIST', index)
          return dispatch('updateListsFile')
            .then(() => {
              // delete the file from disk
              return userSession.deleteFile(listId).then(() => {
                console.log('deleted file: ', listId)
              }).catch(error => {
                console.log(error)
              })
            })
        }
      }
    },
    clearList ({ commit, dispatch }) {
      return dispatch('generateNewList')
        .then(newList => {
          commit('SET_LIST', newList)
        })
    },
    generateNewList () {
      // console.log('Calling Generate New List')
      return {
        id: uuid.v4(),
        title: 'Untitled Map',
        mapInfo: {
          config: {
            longitude: -73.98226832965486,
            latitude: 40.72995403173775,
            zoom: 10.2,
            pitch: 0
          }
        },
        items: [],
        note: '<p></p><p></p>',
        publish: false,
        published: false,
        createdAt: null
      }
    },
    setUserSession ({ commit }) {
      commit('SET_USER_SESSION')
    },
    setUserProperties ({ commit }) {
      commit('SET_USER_PROPERTIES')
    },
    signIn () {
      userSession.redirectToSignIn()
    },
    signOut () {
      userSession.signUserOut(window.location.href)
    }
  }
})

export default store
